import { render, staticRenderFns } from "./AnagraficheDettaglioOperatori.vue?vue&type=template&id=277aa5bc&scoped=true&"
import script from "./AnagraficheDettaglioOperatori.vue?vue&type=script&lang=js&"
export * from "./AnagraficheDettaglioOperatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277aa5bc",
  null
  
)

export default component.exports